import React from 'react';
import { Link } from 'react-router-dom';
import VerificationListSkeleton from '../../Common/VerificationListSkeleton';
import property1 from '../../../../images/property/1.jpg';

const VerificationGridView = ({ 
    propertyVerifyListRows, 
    loading, 
    isPending, 
    isCompleted, 
    handleStatusChange, 
    viewDocument, 
    getStatusColor 
}) => {
    if (loading) {
        return <div className="row"><VerificationListSkeleton count={8} /></div>;
    }

    return (
        <div className="row">
            {propertyVerifyListRows.map((item, ind) => (
                <div className="col-xl-3 col-xxl-4 col-lg-4 col-sm-6" key={item._id}>
                    <div className="card user-card">
                        <div className="card-body pb-0">
                            <div className="d-flex mb-3 align-items-center">
                                <div className="dz-media me-3">
                                    <Link to={`/property-details/${item.propertyId._id}`}>
                                        <img 
                                            src={item.propertyId?.imageUrls?.[0] || property1} 
                                            alt="Property" 
                                            style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 8 }}
                                            onError={(e) => {
                                                e.target.onerror = null; 
                                                e.target.src = property1; 
                                            }}
                                        />
                                    </Link>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="title mb-0">
                                        <Link to={`/property-details/${item.propertyId._id}`}>
                                            {item.propertyId?.title?.length > 20 
                                                ? item.propertyId.title.substring(0, 20) + '...' 
                                                : item.propertyId?.title}
                                        </Link>
                                    </h5>
                                    <small className="text-muted">
                                        Created: {new Date(item.createdAt).toLocaleDateString()} at {new Date(item.createdAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                    </small>
                                    {isCompleted && (
                                        <div className="mt-1">
                                            <span className={`text-${getStatusColor(item.status)}`}>
                                                {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p className="fs-12" title={item.propertyId?.address}>
                                {item.propertyId?.description}
                            </p>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <span className="mb-0 title">Customer Name</span> :
                                    <span className="text-black ms-2">{item?.userId?.name}</span>
                                </li>
                                <li className="list-group-item">
                                    <span className="mb-0 title">Mobile</span> :
                                    <span className="text-black ms-2">{item?.userId?.phone}</span>
                                </li>
                                <li className="list-group-item">
                                    <span className="mb-0 title">Email</span> :
                                    <span className="text-black ms-2">{item?.userId?.email}</span>
                                </li>
                                <li className="list-group-item">
                                    <span className="mb-0 title">Location</span> :
                                    <span className="text-black desc-text ms-2">
                                        {item.propertyId?.address?.length > 80 
                                            ? item.propertyId.address.substring(0, 80) + '...' 
                                            : item.propertyId?.address}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className="card-footer">
                            <div className="d-flex flex-wrap gap-1">
                                {isPending && (
                                    <button 
                                        className="btn btn-danger btn-xs" 
                                        onClick={() => handleStatusChange(item._id, 'pickedup')}
                                    >
                                        Pick Up
                                    </button>
                                )}
                                {!isPending && (
                                    <button 
                                        className="btn btn-primary btn-xs" 
                                        onClick={() => viewDocument(item)}
                                    >
                                        Documents
                                    </button>
                                )}
                                {(!isPending && !isCompleted) && (
                                    <button 
                                        className="btn btn-success btn-xs" 
                                        onClick={() => handleStatusChange(item._id, 'verified')}
                                    >
                                        Mark as Verified
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VerificationGridView;